<template>
 <div>
    <loader :show="enviando"/>
    <b-modal  v-model="mostrar" size="small" title="Agregar actividad industrial y/o empresarial" hide-footer  hide-header-close no-close-on-backdrop>   
    <b-card-body>   
        <b-row>
          <b-col md="12">
            <b-form-group label="Nombre o razón social">
                <b-form-input
                :disabled="enviando"
                v-model="actividad.nombreRazonSocial"
                placeholder="Nombre o razón social"
                @change="cambios = true"
                ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group label="Tipo de negocio ">
                <b-form-input
                :disabled="enviando"
                v-model="actividad.tipoNegocio"
                placeholder="Tipo de negocio"
                @change="cambios = true"
                ></b-form-input>
            </b-form-group>
           </b-col>
          <b-col md="12" >
            <b-form-group label="Remuneración">
                <b-form-input
                :disabled="enviando"
                v-model="actividad.remuneracion.valor"
                @change="cambios = true"
                ></b-form-input>
            </b-form-group>
          </b-col>
          
        </b-row>
         <b-col md="12">
        <b-row style="text-align: center">
          <b-col >
            <b-button :disabled="enviando" variant="danger" size="sm" @click="$emit('cancelar')" >Cancelar</b-button>
          </b-col>
          <b-col v-if="form8">
            <b-button :disabled="enviando" variant="primary" size="sm" @click="guardarActividadIndustial()">Guardar</b-button>
            <p v-if="cambios" class="error-text"> <i>No se han guardado los cambios</i> </p>
          </b-col>
          <b-col v-if="form85">
            <b-button :disabled="enviando" variant="primary" size="sm" @click="guardarAnterior()">Guardarss</b-button>
            <p v-if="cambios" class="error-text"> <i>No se han guardado los cambios</i> </p>
          </b-col>
        </b-row>
      </b-col>
   
    </b-card-body>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import Loader from "../../../views/Loader";
import { mapGetters } from "vuex";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import { required } from "vuelidate/lib/validators";


export default {
  name:"FormactividadIndustial",
  components: { Loader, Datetime,  },
  props: ['mostrar', 'actividadIndustial', 'form8', 'form85'],
  computed: {
    ...mapGetters(["httpURL", "sessionToken"])
  },

  data: function() {
    return {
      enviando: false,
      cambios: false,
     
     actividad:{
       nombreRazonSocial:null,
        remuneracion:{
              valor:null,
              moneda:null
          },
        tipoNegocio:null

      }
 
    };
  },
  watch:{
    'mostrar':function(x){
      //console.log(x);
    },
    'actividadIndustial':function(val){
     // console.log(val);
      if(val){
    //    console.log("hx");
        this.actividad = val;
      }
    }

  },
  methods: {
   guardarActividadIndustial() {
      if (this.actividadIndustial) {
        this.enviando = true;
        axios.put(this.httpURL +"/declaraciones/V2/ingresos/"+this.$route.params.id + "/actividadIndustial/" + this.actividadIndustial._id,
            {
              remuneracionValor: this.actividad.remuneracion.valor,
              remuneracionMoneda: "MXN",
              nombreRazonSocial: this.actividad.nombreRazonSocial,
              tipoNegocio: this.actividad.tipoNegocio
            },
            { headers: { token: this.sessionToken } }
          )
          .then(res => {
            //console.log(res);
            this.cambios = false;
            this.enviando = false;
            let data = {totales:{}, actividad: res.data.actividad};
            if (res.data.ok) {
             if (this.tipoDeclaracion === "INICIAL") {
                    data.totales= {
                        totalesOtros:res.data.totales.otrosIngresosMensualesTotal.valor,
                        totalDeclarante:res.data.totales.ingresoMensualNetoDeclarante.valor,
                        totalIngreso: res.data.totales.totalIngresosMensualesNetos.valor,
                    }
             } else if (this.tipoDeclaracion === "MODIFICACION") {
                  data.totales= {
                        totalesOtros:res.data.totales.otrosIngresosAnualesTotal.valor,
                        totalDeclarante:res.data.totales.ingresoAnualNetoDeclarante.valor,
                        totalIngreso: res.data.totales.totalIngresosAnualesNetos.valor,
                    }
                  
             } else if (this.tipoDeclaracion === "CONCLUSION") {
                  data.totales= {
                        totalesOtros:res.data.totales.otrosIngresosConclusionTotal.valor,
                        totalDeclarante:res.data.totales.ingresoConclusionNetoDeclarante.valor,
                        totalIngreso: res.data.totales.totalIngresosConclusionNetos.valor,
                    }
            }
            this.$emit('industrialModificado',data)
            this.$emit('cancelar')
            this.$notify({group: "foo", type: "success", duration: 2500, speed: 1000, text: res.data.mensaje});
            }
            else {
              this.$notify({ group: "foo", type: "error", duration: 2500, speed: 1000, text: res.data.mensaje });
            }
          })
          .catch(error => {
            this.$notify({ group: "foo", type: "error",  duration: 2500,speed: 1000, text: "No se pudo guardar la sección." });
            this.enviando = false;
          });
      } else {
        axios.post(this.httpURL + "/declaraciones/V2/ingresos/" +this.$route.params.id +"/actividadIndustial",
            {
              remuneracionValor: this.actividad.remuneracion.valor,
              remuneracionMoneda: "MXN",
              nombreRazonSocial: this.actividad.nombreRazonSocial,
              tipoNegocio: this.actividad.tipoNegocio
            },
            { headers: { token: this.sessionToken } }
          )
           .then(res => {
            this.cambios = false;
            this.enviando = false;
            //console.log(res);
            if (res.data.ok) {
                let data = {totales:{}, actividad: res.data.actividad};
                if (this.tipoDeclaracion === "INICIAL") {
                    data.totales= {
                        totalesOtros:res.data.totales.otrosIngresosMensualesTotal.valor,
                        totalDeclarante:res.data.totales.ingresoMensualNetoDeclarante.valor,
                        totalIngreso: res.data.totales.totalIngresosMensualesNetos.valor,
                    }
              } else if (this.tipoDeclaracion === "MODIFICACION") {
                  data.totales= {
                        totalesOtros:res.data.totales.otrosIngresosAnualesTotal.valor,
                        totalDeclarante:res.data.totales.ingresoAnualNetoDeclarante.valor,
                        totalIngreso: res.data.totales.totalIngresosAnualesNetos.valor,
                    }
                  
              } else if (this.tipoDeclaracion === "CONCLUSION") {
                  data.totales= {
                        totalesOtros:res.data.totales.otrosIngresosConclusionTotal.valor,
                        totalDeclarante:res.data.totales.ingresoConclusionNetoDeclarante.valor,
                        totalIngreso: res.data.totales.totalIngresosConclusionNetos.valor,
                    }
              }
              this.$emit('industrialAgregado', data)
               this.$emit('cancelar')
              this.$notify({group: "foo", type: "success", duration: 2500, speed: 1000, text: res.data.mensaje});
            }
            else {
              this.$notify({ group: "foo", type: "error", duration: 2500, speed: 1000, text: res.data.mensaje });
            }
          })
          .catch(error => {
            this.$notify({ group: "foo", type: "error",  duration: 2500,speed: 1000, text: "No se pudo guardar la sección." });
            this.enviando = false;
          });
      }
    },
  guardarAnterior(){
    
    this.enviando=true
      if (this.actividadIndustial){
        axios.put( this.httpURL +"/declaraciones/V2/actividadAnualAnterior/" + this.$route.params.id +"/actividadIndustial/" + this.actividadIndustial._id,
            {
              remuneracionValor: this.actividad.remuneracion.valor,
              remuneracionMoneda: "MXN",
              nombreRazonSocial: this.actividad.nombreRazonSocial,
              tipoNegocio: this.actividad.tipoNegocio
            },
            { headers: { token: this.sessionToken } }
          )
          .then(res => {
         
            if (res.data.ok) {
              this.$emit('industrialAnteriorModificado',res.data.actividad)
              this.cambios= false;
              this.$notify({ group: "foo", type: "success", duration: 2500, speed: 1000,text: res.data.mensaje});
            }
          })

          .catch(error => {
            this.$notify({ group: "foo", type: "error", duration: 2500,  speed: 1000,text: "No se pudo guardar la sección."});
            this.enviando = false;
          });
      } else {
        axios.post(this.httpURL + "/declaraciones/V2/actividadAnualAnterior/" +this.$route.params.id +"/actividadIndustial",
            {
              remuneracionValor: this.actividad.remuneracion.valor,
              remuneracionMoneda: "MXN",
              nombreRazonSocial: this.actividad.nombreRazonSocial,
              tipoNegocio: this.actividad.tipoNegocio
            },
            { headers: { token: this.sessionToken } }
          )
          .then(res => {
         //   console.log(res.data);
            if (res.data.ok) {
              this.$emit('industrialAnteriorAgregado', res.data.actividad)
              this.$notify({  group: "foo", type: "success",  duration: 2500,    speed: 1000, text: res.data.mensaje});
            }
            this.enviando = false;

            this.cambios=false
          })
          .catch(error => {
            this.$notify({ group: "foo",type: "error",  duration: 2500,   speed: 1000, text: "No se pudo guardar la sección."});
            this.enviando = false;
          });
      }
    }
    
  },
  mounted(){
   
    if(this.actividadIndustial){
      //console.log(this.actividadIndustial);
      this.actividad = this.actividadIndustial;
    }

  }
  // mounted() {
  // }
};
</script>

<style>
.customHr {
  width: 100%;
  font-size: 1px;
  color: rgba(0, 0, 0, 0);
  line-height: 1px;

  background-color: grey;
  margin-top: 0px;
  margin-bottom: 10px;
}
.error-texr {
  color: #ff0000;
}
</style>
